import { requestType, SUPPLIER_ENDPOINTS } from "../../constants/Variables";
import Api from "../index";

const createSupplierProduct = (params) => {
  return Api(SUPPLIER_ENDPOINTS.PRODUCT.CREATE, params, requestType.POST);
};

const supplierCreateProduct = (params) => {
  return Api(SUPPLIER_ENDPOINTS.PRODUCT.CREATE, params, requestType.POST);
};

const updateSupplierProduct = (id, params) => {
  return Api(
    SUPPLIER_ENDPOINTS.PRODUCT.UPDATE.replace(":id", id),
    params,
    requestType.PUT,
  );
};

const updateSupplierProductStatus = (id, params) => {
  return Api(
    SUPPLIER_ENDPOINTS.PRODUCT.UPDATE_STATUS.replace(":id", id),
    params,
    requestType.PATCH,
  );
};

const supplierProductsStatusOffOnDowngrade = (id) => {
  return Api(
    SUPPLIER_ENDPOINTS.PRODUCT.STATUS_OFF_ON_DOWNGRADE.replace(":id", id),
    null,
    requestType.PUT,
  );
};

const getAllSupplierProducts = (query) => {
  const ENDPOINT = SUPPLIER_ENDPOINTS.PRODUCT.GET_ALL_PRODUCTS;

  const queryParams = new URLSearchParams();
  if (query.supplierId) queryParams.append("supplierId", query.supplierId);
  if (query.search) queryParams.append("search", query.search);
  if (query.categoryId) queryParams.append("categoryId", query.categoryId);
  if (query.subCategoryId)
    queryParams.append("subCategoryId", query.subCategoryId);
  if (query.subSubCategoryId)
    queryParams.append("subSubCategoryId", query.subSubCategoryId);
  if (query.page) queryParams.append("page", query.page);
  if (query.limit) queryParams.append("limit", query.limit);
  if (query.solutionType)
    queryParams.append("solutionType", query.solutionType);

  const finalUrl = queryParams.toString()
    ? `${ENDPOINT}?${queryParams.toString()}`
    : `${ENDPOINT}`;

  return Api(finalUrl, null, requestType.GET);
};

const getSupplierSingleProductById = (id) => {
  const ENDPOINT = SUPPLIER_ENDPOINTS.PRODUCT.SINGLE_PRODUCT_BY_ID.replace(
    ":id",
    id,
  );
  return Api(ENDPOINT, null, requestType.GET);
};

const updateProductVariantStatus = (id, variantId, params) => {
  const ENDPOINT = SUPPLIER_ENDPOINTS.PRODUCT.UPDATE_VARIANT_STATUS.replace(
    ":id",
    id,
  ).replace(":variantId", variantId);
  return Api(ENDPOINT, params, requestType.PATCH);
};

const getInventoryMovements = (params) => {
  const url = SUPPLIER_ENDPOINTS.PRODUCT.GET_INVENTORY_MOVEMENTS;
  const queryParams = new URLSearchParams();

  if (params.supplierId) queryParams.append("supplierId", params.supplierId);
  if (params.search) queryParams.append("search", params.search);
  if (params.movementType) queryParams.append("reason", params.movementType);
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);

  const finalUrl = queryParams.toString()
    ? `${url}?${queryParams.toString()}`
    : url;
  return Api(finalUrl, null, requestType.GET);
};

const exportInventoryMovements = (query) => {
  const queryParams = new URLSearchParams();
  if (query.supplierId) queryParams.append("supplierId", query.supplierId);
  const finalUrl = queryParams.toString()
    ? `${SUPPLIER_ENDPOINTS.PRODUCT.EXPORT_INVENTORY_MOVEMENTS}?${queryParams.toString()}`
    : SUPPLIER_ENDPOINTS.PRODUCT.EXPORT_INVENTORY_MOVEMENTS;
  return Api(finalUrl, null, requestType.GET);
};

const searchProductBySku = (sku) => {
  return Api(
    SUPPLIER_ENDPOINTS.PRODUCT.SEARCH_PRODUCT_BY_SKU.replace(":sku", sku),
    null,
    requestType.GET,
  );
};

const restockProduct = (id, params) => {
  return Api(
    SUPPLIER_ENDPOINTS.PRODUCT.RESTOCK_PRODUCT.replace(":id", id),
    params,
    requestType.PATCH,
  );
};

const geSupplierProductReviews = (query) => {
  const ENDPOINT = SUPPLIER_ENDPOINTS.PRODUCT.GET_ALL_PRODUCTS_REVIEWS;
  const queryParams = new URLSearchParams();
  if (query.supplierId) queryParams.append("supplierId", query.supplierId);
  if (query.search) queryParams.append("search", query.search);
  if (query.page) queryParams.append("page", query.page);
  if (query.limit) queryParams.append("limit", query.limit);

  const finalUrl = queryParams.toString()
    ? `${ENDPOINT}?${queryParams.toString()}`
    : `${ENDPOINT}`;
  return Api(finalUrl, null, requestType.GET);
};

const exportProducts = (query) => {
  const queryParams = new URLSearchParams();
  if (query.supplierId) queryParams.append("supplierId", query.supplierId);
  return Api(
    `${SUPPLIER_ENDPOINTS.PRODUCT.EXPORT_PRODUCTS}?${queryParams.toString()}`,
    null,
    requestType.GET,
  );
};

export {
  createSupplierProduct,
  exportInventoryMovements,
  geSupplierProductReviews,
  getAllSupplierProducts,
  getInventoryMovements,
  getSupplierSingleProductById,
  restockProduct,
  searchProductBySku,
  supplierCreateProduct,
  supplierProductsStatusOffOnDowngrade,
  updateProductVariantStatus,
  updateSupplierProduct,
  updateSupplierProductStatus,
  exportProducts,
};
